import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';


const JobDetailsForm = ({ formData, errors, onChange }) => {
  const jobTypeOptions = [
    { value: 'Full Time', label: 'Full Time' },
    { value: 'Part Time', label: 'Part Time' },
    { value: 'Internship', label: 'Internship' },
    { value: 'Contract', label: 'Contract' }
  ];

  const workArrangementOptions = [
    { value: 'onsite', label: 'Onsite' },
    { value: 'remote', label: 'Remote' },
    { value: 'hybrid', label: 'Hybrid' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Job Title"
          type="text"
          placeholder="e.g., Software Engineer, Marketing Intern"
          value={formData?.title}
          onChange={(e) => onChange('title', e?.target?.value)}
          error={errors?.title}
          required
        />
        <Input
          label="Company Name"
          type="text"
          placeholder="Enter company name"
          value={formData?.company}
          onChange={(e) => onChange('company', e?.target?.value)}
          error={errors?.company}
          required
        />
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          Company Description <span className="text-destructive">*</span>
        </label>
        <textarea
          className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="Describe your company, its mission, and culture..."
          value={formData?.companyDescription}
          onChange={(e) => onChange('companyDescription', e?.target?.value)}
          rows={4}
        />
        {errors?.companyDescription && (
          <p className="text-sm text-destructive mt-1">{errors?.companyDescription}</p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Job Type"
          options={jobTypeOptions}
          value={formData?.type}
          onChange={(value) => {
            onChange('type', value);
            onChange('isInternship', value === 'Internship');
          }}
          error={errors?.type}
          required
        />
        <Select
          label="Work Arrangement"
          options={workArrangementOptions}
          value={formData?.workArrangement}
          onChange={(value) => onChange('workArrangement', value)}
          error={errors?.workArrangement}
          required
        />
      </div>

      <Input
        label="Location"
        type="text"
        placeholder="e.g., Mumbai, Maharashtra"
        value={formData?.location}
        onChange={(e) => onChange('location', e?.target?.value)}
        error={errors?.location}
        required
      />

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          Role Responsibilities <span className="text-destructive">*</span>
        </label>
        <textarea
          className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="List key responsibilities and day-to-day tasks...\n• Responsibility 1\n• Responsibility 2\n• Responsibility 3"
          value={formData?.responsibilities}
          onChange={(e) => onChange('responsibilities', e?.target?.value)}
          rows={6}
        />
        {errors?.responsibilities && (
          <p className="text-sm text-destructive mt-1">{errors?.responsibilities}</p>
        )}
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          Required Qualifications
        </label>
        <textarea
          className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="List required qualifications and preferred qualifications...\n• Bachelor's degree in relevant field\n• 2+ years of experience\n• Strong communication skills"
          value={formData?.qualifications}
          onChange={(e) => onChange('qualifications', e?.target?.value)}
          rows={5}
        />
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          Salary Range (LPA)
        </label>
        <div className="grid grid-cols-2 gap-4">
          <Input
            type="number"
            placeholder="Min (e.g., 3)"
            value={formData?.salaryMin}
            onChange={(e) => onChange('salaryMin', e?.target?.value)}
          />
          <Input
            type="number"
            placeholder="Max (e.g., 6)"
            value={formData?.salaryMax}
            onChange={(e) => onChange('salaryMax', e?.target?.value)}
          />
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Leave blank for unpaid positions or if salary is negotiable
        </p>
      </div>
    </div>
  );
};

export default JobDetailsForm;